import { apiFetch } from '../../lib/api/client.js';
import type { PopupItem } from './select.js';

export const POPUP_QUERY_KEYS = {
  active: ['popups', 'active'] as const,
};

export interface ActivePopups {
  items: PopupItem[];
  /**
   * Today's impression count per popup id for the signed-in member, or an empty
   * record for an anonymous visitor. It rides back on this response rather than
   * on an endpoint of its own — the lobby needs both to decide anything, and a
   * second round trip on first paint buys nothing.
   */
  impressions: Record<string, number>;
}

export async function fetchActivePopups(): Promise<ActivePopups> {
  const res = await apiFetch<{ items: PopupItem[]; impressions?: Record<string, number> }>(
    '/popups?active=true&pageSize=20',
  );
  return { items: res.items ?? [], impressions: res.impressions ?? {} };
}

/**
 * Count one impression against the signed-in member's daily allowance.
 *
 * Called when a popup actually reaches the screen, not on lobby load, so the
 * write volume is bounded by the creative's own cap. A failure is swallowed by
 * the caller: the member sees the popup either way, and the worst case is one
 * uncounted impression, which is exactly the pre-#231 behaviour.
 */
export async function recordPopupImpression(popupId: string): Promise<void> {
  await apiFetch('/popup-impressions', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ popupId }),
  });
}
